import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ThumbsUpButton.module.css";
import thumbsUp from "./thumbsUp.png";

/**
 *
 */
export function ThumbsUpButton({ isLocked, isGrayed, onClick }) {
  return (
    <div onClick={isLocked ? null : onClick}>
      <button
        className={classNames(
          styles.imageContainer,
          isGrayed ? styles.grayBg : styles.greenBg,
          isLocked ? styles.noPointerOnHover : styles.cursorPointerOnHover
        )}
      >
        <img src={thumbsUp} className={classNames(styles.image)} />
      </button>
    </div>
  );
}

ThumbsUpButton.propTypes = {
  isLocked: PropTypes.bool,
  isGrayed: PropTypes.bool,
  onClick: PropTypes.func,
};
